import { httpCreate } from './http';

const http = httpCreate('/srv/record-live');

export const recordLive = {
	getInfo(activityId) {
		return http.get(`/${activityId}`);
	},
	addVideo(activityId, data) {
		return http.put(`/${activityId}`, data);
	},
	setTime(activityId, data) {
		return http.put(`/crontab/${activityId}`, data);
	},
	start(activityId) {
		return http.get(`/start/${activityId}`);
	},
	stop(activityId) {
		return http.get(`/stop/${activityId}`);
	},
	clear(activityId) {
		return http.delete(`/${activityId}`);
	},
};
